<template>
  <div class="body_div" style="background: #FFFFFF;">
    <!--头部-->
    <div class="sj_top">
      <p>{{ courseName }}</p>
    </div>
    <!--中间-->
    <div class="sj_all" style="background: #FFFFFF;">
      <div class="sj_main">
        <!--中间左面试题部分-->
        <div class="sjm_left">
          <!--试卷信息-->
          <div class="paper_info">
            <div class="pi_title">概　述</div>
            <div class="pi_left" style="width:100%">
              <p style="width: 230px;">考生姓名：<span>{{ userInfo.realName }}</span></p>
              <p style="width: 230px;">试卷总分：<span>100分</span></p>
              <p style="width: 230px;">达标要求：<span style="color: red">{{ scoreRequired }}分合格</span></p>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>
          <!--选择题-->
          <div class="test_type">
            <div class="tt_title">一、单项选择题（共{{ practice.length }}题，共计100分）</div>
            <div class="tt_main">
              <!--单个试题-->
              <div v-for="(item, index) in practice" :id="'question'+(index+1)" :name="'question'+(index+1)"
                class="ttm_cell">
                <div class="ttm_title"><span class="shiti_tihao">{{ index + 1 }}.</span><span
                  v-html="filterStem(item.stem)"></span>（{{ parseInt(100 / practice.length) }}分）<label><input
                  v-model="status[index].noIdea" type="checkbox" @click="buqueding(index)"/> 答案不确定</label></div>
                <ul class="ttm_items">
                  <li v-for="(itemChild, indexChild) in item.opts"><label><input :name="'option'+(index+1)"
                    type="radio" @click="dati(index,itemChild.opt,item.ans)"><span
                    v-html="filterCtnt(itemChild.opt,itemChild.ctnt)"></span></label></li>
                </ul>
              </div>
              <!--单个试题-->
            </div>
          </div>
          <!--提交答卷-->
          <div class="sjm_submit"><a v-show="commitButtonShow" href="javascript:" @click="commit()">我 要 交 卷</a>
          </div>
        </div>
        <!--中间右边浮层工具栏-->
        <div class="sjm_right">
          <div class="sjmr_title">答题卡：{{ already }}/{{ practice.length }}</div>
          <div class="sjmr_tips">
            <div class="sjmrt"><a class="tip_right" href="javascript:"></a>已做</div>
            <div class="sjmrt"><a class="tip_wrong" href="javascript:"></a>未做</div>
            <div class="sjmrt"><a class="tip_not" href="javascript:"></a>不确定</div>
          </div>
          <div class="sjmr_main">
            <div class="tools_cell">
              <div class="tc_title">单选题({{ practice.length }}道，共100分)</div>
              <div class="tc_main">
                <ul>
                  <li v-for="(item, index) in practice"><a
                    :class="{'tc_right':status[index].res==1,'tc_wrong':status[index].res==0 || status[index].res==2,'tc_not':status[index].noIdea==true}"
                    href="javascript:"
                    @click="maodiandingwei(index+1)">{{ index + 1 }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="sjmr_notice">注：点击题序可跳转到相应试题内容</div>
          <div class="sjmr_clear"><a href="javascript:" @click="clear">清空记录</a></div>
        </div>
      </div>
    </div>
    
    <!--提交答卷弹出层-->
    <el-dialog :before-close="closeDetail" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="true" :visible.sync="detailShow"
      title="答题成绩" width="30%">
      <div class="submit_disk">
        <div class="sbd_title">成绩：{{ parseInt(rightNum * 100 / practice.length) }}分</div>
        <div class="sbd_main">
          <div class="sbdm_cell">
            <div class="sbdm_title">单选题({{ practice.length }}道，共100分)</div>
            <div class="sbdm_main">
              <ul>
                <li v-for="(item, index) in practice">
                  <span>{{ index + 1 }}</span>
                  <svg v-if="status[index].detail==1" aria-hidden="true" class="icon">
                    <use xlink:href="#icon-selected"></use>
                  </svg>
                  <svg v-else-if="status[index].detail==-1" aria-hidden="true" class="icon">
                    <use xlink:href="#icon-shixincuohao"></use>
                  </svg>
                  <svg v-else="status[index].detail!=0" aria-hidden="true" class="icon">
                    <use xlink:href="#icon-jinggao"></use>
                  </svg>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="sbd_tips">
          <div class="sbdt">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-selected"></use>
            </svg>
            <span>正确</span>
          </div>
          <div class="sbdt">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-shixincuohao"></use>
            </svg>
            <span>错误</span>
          </div>
          <div class="sbdt">
            <svg aria-hidden="true" class="icon">
              <use xlink:href="#icon-jinggao"></use>
            </svg>
            <span>不确定</span>
          </div>
          <a v-show="confirmButtonShow" class="sbd_qding" href="javascript:void(0);" @click="closeDetail">确定</a>
        </div>
      </div>
    </el-dialog>
    <!-- 返回顶部 -->
    <div id="top2"></div>
  </div>
</template>

<script>
import { commitCoursePracticeScore, getTrainingById, getTrainingInfoById } from '../../api/api'
import { mapGetters } from 'vuex'
import jsonp from 'jsonp'
import { VerifyDeviceBinding } from '../../utils/fingerprint'

export default {
  components: {},
  data() {
    return {
      trainingId: this.$route.query.trainingId,
      projectId: this.$route.query.projectId,
      courseFieldID: this.$route.query.courseFieldID,
      courseId: this.$route.query.courseId,
      courseName: this.$route.query.courseName,
      practice: [],
      detailShow: false,
      already: 0,
      status: [],
      rightNum: 0,
      confirmButtonShow: false,
      businessType: 0,
      commitButtonShow: true,
      scoreRequired: 100
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      /*55个专家讲座的项目，展示10个练习题*/
      var practiceUrl = process.env.EXAM_API_URL + 'course/practices/' + this.courseFieldID
      if (this.$route.query.setTop == 1) {
        practiceUrl = process.env.EXAM_API_URL + 'course/practices/' + this.courseFieldID + '?size=10'
      }
      jsonp(practiceUrl, (err, data) => {
        this.practice = data.data
        for (var i = 0; i < this.practice.length; i++) {
          this.status[i] = {'res': 0, 'detail': 0, 'noIdea': false}
        }
      })
      getTrainingInfoById({//获得项目和课程状态
        trainingId: this.trainingId
      }).then((response) => {
        this.scoreRequired = response.data.data.trainingInfo.practiceScore
        this.businessType = response.data.data.trainingInfo.businessType
        if (response.data.data.trainingInfo.limitSingleDeviceLearning === 1) {
          VerifyDeviceBinding(this.userInfo.id)
        }
      })
    },
    clear() {
      this.practice = []
      this.detailShow = false
      this.already = 0
      this.status = []
      this.rightNum = 0
      this.confirmButtonShow = false
      this.businessType = 0
      this.init()
    },
    /*过滤选项*/
    filterCtnt(opt, ctnt) {
      ctnt = ctnt.replace(/<p>([\s\S]*?)<\/p>/ig, '$1')
      ctnt = ctnt.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      return opt + '、' + ctnt
    },
    maodiandingwei(maodian) {
      var yuansu_top = document.getElementById('question' + maodian).offsetTop
      window.scrollTo(0, yuansu_top - 20)
    },
    /*过滤题干*/
    filterStem(stem) {
      stem = stem.replace(/(\n)/g, '')
      stem = stem.replace(/(\t)/g, '')
      stem = stem.replace(/(\r)/g, '')
      if (stem.indexOf('<sub>') > 0) {
        stem = stem.replace(/<sub>/g, '-----sub-----')
        stem = stem.replace(/<\/sub>/g, '-----.sub-----')
      }
      if (stem.indexOf('<sup>') > 0) {
        stem = stem.replace(/<sup>/g, '-----sup-----')
        stem = stem.replace(/<\/sup>/g, '-----.sup-----')
      }
      stem = stem.replace(/<\/?[^>]*>/g, '')
      stem = stem.replace(/\s*/g, '')
      stem = stem.replace(/<.*?>/ig, '')
      stem = stem.replace(/<p>([\s\S]*?)<\/p>/ig, '$1')
      stem = stem.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      stem = stem.replace(/-----sub-----/g, '<sub>')
      stem = stem.replace(/-----.sub-----/g, '</sub>')
      stem = stem.replace(/-----sup-----/g, '<sup>')
      stem = stem.replace(/-----.sup-----/g, '</sup>')
      return stem
    },
    commit() {
      this.detailShow = true
      //this.commitButtonShow=false;
      for (var i = 0; i < this.status.length; i++) {
        if (this.status[i].detail == 1) {
          this.rightNum++
        }
      }
      commitCoursePracticeScore({
        trainingId: this.trainingId,
        projectId: this.projectId,
        userId: this.userInfo.id,
        courseId: this.courseId,
        score: (100 / this.practice.length * this.rightNum) > 99 ? Math.ceil(100 / this.practice.length * this.rightNum) : parseInt(100 / this.practice.length * this.rightNum),
        versionId: '3.1'
      }).then((response) => {
        if (response.data.result == 1) {
          //当分数未大于上次提交分数时还提示<保存成功>：不合理，这里将其去掉
          /*this.$message({
           message: response.data.errMsg,
           type: 'success'
           });*/
          this.confirmButtonShow = true
        } else {
          this.$message.error(response.data.errMsg)
        }
      })
    },
    /*关闭答题明细*/
    closeDetail() {
      //达到100分关闭本页面
      if (100 / this.practice.length * this.rightNum > 99) {
        if (!this.$route.query.parentPage) {
          if (this.businessType == 102) {
            if (window.opener && !window.opener.closed) {
              window.opener.location.href = '/usercenter/projectDtail?trainingId=' + this.$route.query.trainingId + '&projectId=' + this.$route.query.projectId
            }
          } else {
            if (window.opener && !window.opener.closed) {
              window.opener.location.href = '/usercenter/index?trainingId=' + this.$route.query.trainingId
            }
          }
        }
        window.close()
      }
      //未达到的关闭答题明细，可以继续修改提交
      this.detailShow = false
      this.rightNum = 0
      location.reload()
    },
    /*试题不确定*/
    buqueding(index) {
      //1:已做；0：不确定；否则未做
      if (this.status[index].noIdea == true) {
        if (this.status[index].res == 1) {
          let status = this.status[index]
          status.res = -1
          this.$set(this.status, index, status)
        } else if (this.status[index].res == 0) {
          let status = this.status[index]
          status.res = -2
          this.$set(this.status, index, status)
        }
      } else if (this.status[index].noIdea == false) {
        if (this.status[index].res == -1) {
          let status = this.status[index]
          status.res = 1
          this.$set(this.status, index, status)
        } else if (this.status[index].res == -2) {
          let status = this.status[index]
          status.res = 2
          this.$set(this.status, index, status)
        }
      }
    },
    /*试题作答*/
    dati(index, opt, ans) {
      /*记录已答题数*/
      if (this.status[index].res == 0 || this.status[index].res == -2) {
        this.already = this.already + 1
      }
      let status = this.status[index]
      status.res = 1
      this.$set(this.status, index, status)
      
      /*判断对错*/
      if (opt == ans) {
        status.detail = 1
        this.$set(this.status, index, status)
      } else {
        status.detail = -1
        this.$set(this.status, index, status)
      }
    },
    /**
     * @description: 查询培训班详情
     */
    getTrainingById() {
      const params = {
        id: this.$route.query.trainingId,
        userId: this.userInfo.id
      }
      getTrainingById(params).then((res) => {
        const training = res.data.data.training
        this.trainingInfo = training || {}
        if (training.limitSingleDeviceLearning === 1) {
          VerifyDeviceBinding(this.userInfo.id)
        }
      })
    }
  }
}
</script>

<style scoped>
.body_div {
  font-size: 14px;
  height: 100vh;
  padding-top: 60px;
}

.sj_top {
  position: fixed;
  z-index: 9;
  top: 0px;
  width: 100%;
  height: 60px;
  background: #38BCD5;
}

.sj_top > p {
  font-size: 24px;
  line-height: 60px;
  width: 980px;
  height: 60px;
  margin: 0 auto;
  text-align: center;
  color: #FFFFFF;
}

.sj_all {
  width: 100%;
  min-width: 980px;
}

.sj_main {
  position: relative;
  width: 980px;
  margin: 0 auto;
  padding-top: 10px;
}

.sjm_left {
  width: 722px;
  padding-top: 10px;
}

.paper_info {
  position: relative;
  width: 722px;
  padding: 10px 0px 10px 20px;
  border: 1px #DDDDDD solid;
}

.pi_title {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  position: absolute;
  top: -12px;
  left: 52px;
  width: 80px;
  height: 20px;
  text-align: center;
  background: #FFFFFF;
}

.pi_left {
  float: left;
  width: 481px;
}

.pi_left > p {
  line-height: 32px;
  float: left;
  overflow: hidden;
  width: 240px;
  height: 32px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pi_left > p > span {
  color: #017CB6
}

.pi_left > p > select {
  border: 1px #B8B8B8 solid;
}

.test_type {
  width: 722px;
  padding-top: 10px;
}

.test_type .tt_title {
  font-size: 22px;
  line-height: 50px;
  position: relative;
  height: 50px;
}

.test_type .tt_title .ttt_df {
  line-height: 50px;
  position: absolute;
  top: 0;
  right: 60px;
  width: 150px;
  height: 50px;
  text-align: right;
}

.test_type .tt_title .ttt_df span {
  color: #ED1C24;
}

.test_type .tt_main {
  width: 722px;
}

.test_type .tt_main .ttm_cell {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px #DDDDDD solid;
}

.test_type .tt_main .ttm_cell .ttm_cell {
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-left: 30px;
}

.test_type .tt_main .ttm_cell .ttm_title {
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  padding-bottom: 8px;
}

.test_type .tt_main .ttm_cell .ttm_title label {
  line-height: 24px;
  position: relative;
  display: inline-block;
  height: 24px;
  padding-left: 18px;
}

.test_type .tt_main .ttm_cell .ttm_title label:hover {
  cursor: pointer;
  color: #38BCD5;
}

.test_type .tt_main .ttm_cell .ttm_title label > input {
  position: absolute;
  top: 6px;
  left: 0px;
}

.ttm_title span.shiti_tihao {
  font-size: 18px;
  font-weight: bold;
  font-style: italic;
  padding-right: 5px;
}

.test_type .tt_main .ttm_cell ul.ttm_items {
}

.test_type .tt_main .ttm_cell ul.ttm_items li {
  border-radius: 5px;
}

.test_type .tt_main .ttm_cell ul.ttm_items li label {
  line-height: 20px;
  position: relative;
  display: block;
  padding: 5px 0px 5px 27px;
  cursor: pointer;
}

.test_type .tt_main .ttm_cell ul.ttm_items li:hover {
  background: #CCCCCC;
}

.test_type .tt_main .ttm_cell ul.ttm_items li label input[type=radio], .test_type .tt_main .ttm_cell ul.ttm_items li label input[type=checkbox] {
  position: absolute;
  top: 9px;
  left: 8px;
}

* + html .test_type .tt_main .ttm_cell ul.ttm_items li label input[type=radio], * + html .test_type .tt_main .ttm_cell ul.ttm_items li label input[type=checkbox] {
  position: absolute;
  top: 5px;
  left: 8px;
}

.test_type .tt_main .ttm_cell ul.ttm_items li label span {
  padding-right: 5px;
}

.test_type .tt_main .ttm_cell ul.ttm_items3 {
}

.test_type .tt_main .ttm_cell ul.ttm_items3 li label {
  line-height: 20px;
  position: relative;
  display: block;
  padding: 5px 0px 5px 20px;
  cursor: pointer;
}

.test_type .tt_main .ttm_cell ul.ttm_items3 li label span {
  font-weight: bold;
  padding-right: 5px;
}

.sjm_submit {
  padding: 24px 0px;
  text-align: center;
}

.sjm_submit a {
  font-size: 16px;
  font-weight: bold;
  line-height: 40px;
  display: inline-block;
  width: 30%;
  height: 40px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 8px;
  background: #38BCD5;
}

.sjm_submit a:hover {
  background: #0D9AB5;
}

.sjm_right {
  position: fixed;
  z-index: 9;
  top: 80px;
  width: 243px;
  margin-left: 734px;
  border-radius: 0px;
  background: #E8E8E8;
}

.sjmr_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 42px;
  width: 243px;
  height: 42px;
  text-align: center;
  color: #FFFFFF;
  background: #38BCD5
}

.sjmr_tips {
  line-height: 20px;
  overflow: hidden;
  height: 41px;
  padding: 10px 12px;
}

.sjmrt {
  position: relative;
  float: left;
  width: 33.3%;
  padding-left: 24px;
}

.sjmrt a {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  width: 20px;
  height: 20px;
  cursor: default;
}

a.tip_right {
  background: #38BCD5;
}

a.tip_wrong {
  background: #FFA75D;
}

a.tip_not {
  background: #BBBBBB;
}

.sjmr_main {
  overflow-y: auto;
  width: 243px;
  height: 55vh;
  border: 1px #DDDDDD solid;
  border-top: 0;
  border-bottom: 0;
  background: #FFFFFF;
}

.sjmr_main .tools_cell {
}

.tools_cell .tc_title {
  font-weight: bold;
  line-height: 34px;
  overflow: hidden;
  height: 34px;
  padding-left: 10px;
  color: #000000;
}

.tools_cell .tc_title span {
  font-weight: normal;
}

.tools_cell .tc_main {
  padding-left: 10px;
}

.tools_cell .tc_main ul {
  overflow: hidden;
}

.tools_cell .tc_main ul li {
  float: left;
  overflow: hidden;
  width: 30px;
  height: 30px;
}

.tools_cell .tc_main ul li a {
  font-size: 12px;
  line-height: 24px;
  display: block;
  width: 24px;
  height: 24px;
  text-align: center;
  color: #FFFFFF;
}

.tools_cell .tc_main ul li a.tc_right {
  background: #38BCD5;
}

.tools_cell .tc_main ul li a.tc_right:hover {
  background: #21A9C3;
}

.tools_cell .tc_main ul li a.tc_wrong {
  background: #FFA75D;
}

.tools_cell .tc_main ul li a.tc_wrong:hover {
  background: #D87B2C;
}

.tools_cell .tc_main ul li a.tc_not {
  background: #BBBBBB;
}

.tools_cell .tc_main ul li a.tc_not:hover {
  background: #AAAAAA;
}

.sjmr_notice {
  font-size: 12px;
  line-height: 34px;
  height: 34px;
  text-align: center;
  color: #333333;
}

.sjmr_clear {
  padding-bottom: 15px;
  text-align: center;
}

.sjmr_clear a {
  font-size: 14px;
  line-height: 24px;
  display: inline-block;
  width: 60%;
  height: 24px;
  margin: 0 auto;
  text-align: center;
  color: #FFFFFF;
  border-radius: 6px;
  background: #FF5300;
}

.sjmr_clear a:hover {
  background: #C34B11;
}

.submit_disk {
  width: 98%;
  margin: 0 auto;
}

.sbd_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  height: 24px;
  margin-bottom: 12px;
  text-align: center;
  color: #38BCD5;
}

.sbd_main {
  overflow-y: auto;
  height: 340px;
  margin: 8px 0px;
  padding: 12px;
  padding-top: 6px;
  border: 1px #DDDDDD solid;
}

.sbdm_cell {
}

.sbdm_cell .sbdm_title {
  font-size: 14px;
  line-height: 30px;
  height: 30px;
}

.sbdm_cell .sbdm_main {
}

.sbdm_cell .sbdm_main ul {
  overflow: hidden
}

.sbdm_cell .sbdm_main ul li {
  float: left;
  overflow: hidden;
  width: 40px;
  height: 48px;
  margin-bottom: 10px;
}

.sbdm_cell .sbdm_main ul li span {
  font-size: 12px;
  line-height: 24px;
  display: block;
  width: 40px;
  height: 24px;
  text-align: center;
}

.sbdm_cell .sbdm_main ul li svg {
  display: block;
  width: 24px;
  height: 24px;
  margin: 0px auto
}

.sbd_tips {
  overflow: hidden;
  padding-left: 25px;
}

.sbd_tips .sbdt {
  font-size: 14px;
  float: left;
  width: 80px;
  height: 24px;
}

.sbd_tips .sbdt svg {
  display: inline-block;
  float: left;
  width: 24px;
  height: 24px;
}

.sbd_tips .sbdt span {
  line-height: 24px;
  display: inline-block;
  float: left;
  height: 24px;
  padding-left: 5px;
}

.sbd_tips a.sbd_qding {
  font-size: 14px;
  line-height: 24px;
  display: block;
  float: right;
  width: 80px;
  height: 24px;;
  margin-right: 12px;
  text-align: center;
  color: #FFFFFF;
  border-radius: 4px;
  background: #38BCD5;
}

.sbd_tips a.sbd_qding:hover {
  background: #0D9AB5;
}
</style>



// WEBPACK FOOTER //
// src/views/usercenter/PracticeAfterCourse.vue